import { Box } from "@fullscript/aviary-web";
import { faInfoCircle } from "@fullscript/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";

import { Arrange, Typography } from "@aviary";
import { FontAwesomeIcon } from "@shared/react-fontawesome/react-fontawesome";
import { l } from "@unauthenticated/shared/locales/i18n";

const ActivateKitMessage = () => {
  const { t } = useTranslation();

  return (
    <Box padding="small">
      <Arrange isWrapped={false}>
        <FontAwesomeIcon icon={faInfoCircle} />
        <Typography isMarginless>{t(l.signIn.activateLabKit)}</Typography>
      </Arrange>
    </Box>
  );
};

export { ActivateKitMessage };
